import React from 'react'
import PropTypes from 'prop-types'
import { useDragLayer } from 'react-dnd'
import { mergeProps } from 'src/util'
import styles from './DragLayer.scss'

function getItemStyles(currentOffset) {
  if (!currentOffset) {
    return { display: 'none' }
  }
  return { transform: `translate(${currentOffset.x}px, ${currentOffset.y}px)` }
}

const DragLayer = ({ component: Component, ...domProps }) => {
  const [{ data, type }, currentOffset] = useDragLayer(monitor => [monitor.getItem() || {}, monitor.getClientOffset()])

  return (
    <div {...mergeProps()({ className: styles.dragLayer }, domProps)}>
      <div style={getItemStyles(currentOffset)}>
        <Component itemType={type} item={data} />
      </div>
    </div>
  )
}

DragLayer.propTypes = {
  component: PropTypes.func.isRequired,
}

export default DragLayer
